import { Q as QBusImpl } from './lib/b05b90b2.mjs';
export { Q as QBusImpl, a as addModuleSubscription, b as addSubscription, p as publish, r as removeSubscription } from './lib/b05b90b2.mjs';
import './lib/ea273712.mjs';

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function eventQBus() {
    return new QBusImpl();
}

export { eventQBus };
/*                              */
